export default {
    cz: {
        toDetail: 'Detail zapůjčení',
        unit: (unit: string) => `za ${unit}`,
        withDPH: 's DPH',
        addToCart: 'Přidat',
        addedToCart: 'Přidáno',
    },
    sk: {
        toDetail: 'Detail zapožičania',
        unit: (unit: string) => `za ${unit}`,
        withDPH: 's DPH',
        addToCart: 'Pridať',
        addedToCart: 'Pridané',
    },
}
